import { combineReducers } from 'redux';
import tabReducer from './tabReducer';
import infoReducer from './infoReducer';
import selectionReducer from './selectionReducer';
import dataReducer from './dataReducer';
import dataChartReducer from './dataChartReducer';
import configReducer from './configReducer';
import pendingReducer from './pendingReducer';
import pxqReducer from './pxqReducer';
import errorReducer from './errorReducer';
import columnReducer from './columnReducer';
import infoReducerDescription from './infoReducerDescription';
import radioReducer from './radioReducer';
import pendingCharReducer from './pendingCharReducer';
import infoCargaChart from './infoChart';
import metaChartReducer from './metaChartReducer';
import chartLineReducer from './chartReducer';
import checkEstReducer from './checkEstReducer';
import checkHideRowsReducer from './checkHideRowReducer';
import collapseMenuPest1Reducer from './collapseMenuPest1Reducer';
import collapseMenuPest2Reducer from './collapseMenuPest2reducer';

/*   Los Reducer son esas funciones puras que toman el estado anterior del contexto donde son invocadas
     y devuelve el nuevo estado */
     
export default combineReducers({
    //función raiz que combina todos los Reducers
  
    metadata: tabReducer,
    metaChart: metaChartReducer,
    info: infoReducer,
    infoDescription: infoReducerDescription,
    infoChart: infoCargaChart,
    selection: selectionReducer,
    radio: radioReducer,
    selectionChartLine: chartLineReducer,
    data: dataReducer,
    dataChart: dataChartReducer,
    config: configReducer,
    pending: pendingReducer,
    pendingChart: pendingCharReducer,
    pxqUrl: pxqReducer,
    error: errorReducer,
    column: columnReducer,
    checkEst: checkEstReducer,
    checkHideR: checkHideRowsReducer,
    collapseMenuPest1: collapseMenuPest1Reducer,
    collapseMenuPest2: collapseMenuPest2Reducer

    
})
